// cSpell:ignore unmount
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setItemModel, confirmDeleteItem } from "../../actions/listing";
import Listing from "../Listing";

class BlacklistListing extends Component {
  static propTypes = {
    // Injected by React-Router
    history: PropTypes.object.isRequired,
    // Injected by React-Redux
    setItemModel: PropTypes.func.isRequired,
    confirmDeleteItem: PropTypes.func.isRequired
  };

  model = "blacklist";

  componentWillMount = () => {
    this.props.setItemModel(this.model);
  };

  render() {
    const { history, confirmDeleteItem } = this.props,
      fields = {
        serial: { title: "#", type: "serial" },
        ip: { title: "IP" },
        description: { title: "Description" },
        created: {
          title: "Created",
          type: "date",
          format: "YYYY-MM-DD hh:mm",
          sortable: true
        },
        actions: { title: "Actions", type: "actions" }
      },
      actions = [
        {
          name: "Delete",
          type: "negative",
          icon: "trash",
          handler: id => {
            confirmDeleteItem(id);
          }
        }
      ];
    return (
      <Listing
        title="License blacklist"
        model={this.model}
        mainField="ip"
        // list config
        fields={fields}
        actions={actions}
        defaultSort={{ created: -1 }}
        onAdd={() => {
          history.push(`/${this.model}/add`);
        }}
        simpleSearchTitle="Exact IP"
        getSimpleSearch={search => ({
          ip: search
        })}
      />
    );
  }
}

export default withRouter(
  connect(
    null,
    {
      setItemModel,
      confirmDeleteItem
    }
  )(BlacklistListing)
);
